//--- Обновление записи последней проверки
window.dataProverkiUpdate = function (element){
    $.ajax({
        url: 'ajaxHandler.php',
        type: "POST",
        data:{
           request: 'dataProverkiUpdate',
           indexIcao: $(element).data('indexicao'),
           idTech: $(element).data('idtech'),
        },
        dataType : "json",
        success: function (data, textStatus) {

            if(data != false){

                alert('Дата проверки обновлена.');
                $('.dataProverki').text("Проверка: " + data.dataProverkiStr);

            }else{
                alert('Ошибка! Попробуйте повторить позднее.');
            }

        },
        error: function (){

            alert('Ошибка! Попробуйте повторить позднее.');

        }
    });
}